<script setup>
import { env } from '@/config/env'
import FloatingAgent from '@/components/FloatingAgent.vue'
import { getUrlParam } from '@/utils/urlUtils'

// 在开发环境下显示环境信息
const showEnvInfo = env.isDevelopment || env.DEBUG

// 获取url的appType存储起来
const appType = getUrlParam('appType')
</script>

<template>
  <!-- 路由视图 -->
  <router-view />

  <!-- 漂浮代理组件 -->
  <FloatingAgent v-if="appType === '41'" />

  <!-- 环境信息卡片 - 仅在开发环境显示 -->
  <div v-if="showEnvInfo" class="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 bg-gray-800/90 backdrop-blur-xl rounded-2xl sm:rounded-3xl shadow-2xl border border-gray-700/50 p-4 sm:p-6 max-w-xs">
    <h3 class="text-sm sm:text-base font-medium text-white mb-2 sm:mb-3">环境信息</h3>
    <div class="space-y-1.5 sm:space-y-2 text-xs sm:text-sm text-gray-300">
      <p class="flex justify-between">
        <span class="font-medium">环境:</span>
        <span class="text-white">{{ env.APP_ENV }}</span>
      </p>
      <p class="flex justify-between">
        <span class="font-medium">版本:</span>
        <span class="text-white">{{ env.APP_VERSION }}</span>
      </p>
      <p class="flex justify-between">
        <span class="font-medium">API地址:</span>
        <span class="text-white text-xs">{{ env.API_BASE_URL_API }}</span>
      </p>
      <p class="flex justify-between">
        <span class="font-medium">调试模式:</span>
        <span class="text-white">{{ env.DEBUG ? '开启' : '关闭' }}</span>
      </p>
    </div>
  </div>
</template>

<style scoped></style>
